module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-down.7a5fa4d7.svg";